export const UNREALIZED_PNL = {
  prefix: "$",
  value: 21318.58432,
  suffix: "",
  change: 0,
  changeSuffix: "",
  decimals: 0,
};
